module.exports = __webpack_public_path__ + "img/logo_dinamo_high_light.36a5c740.png";